import React from "react";
import { Progress, Typography } from "antd";

const { Text } = Typography;

interface ProgressWithDetailProps {
  label: string;
  percentage: number;
  leftValue: string;
  rightValue: string;
}

const ProgressWithDetail: React.FC<ProgressWithDetailProps> = React.memo(
  ({ label, percentage, leftValue, rightValue }) => {
    return (
      <div style={{ marginTop: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text
            style={{
              color: "#3E7898",
              fontSize: 16,
              margin: 0,
              fontWeight: 700,
            }}
          >
            {label}
          </Text>
          <Text
            style={{
              color: "#3E7898",
              fontSize: 16,
              margin: 0,
              fontWeight: 700,
            }}
          >
            {percentage}
          </Text>
        </div>

        <Progress
          percent={percentage}
          strokeColor="#1F5782"
          trailColor="#FFFFFF"
          strokeWidth={8}
          showInfo={false}
          strokeLinecap="round"
        />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Text
            style={{
              color: "#234D64",
              fontSize: 12,
            }}
          >
            {/* {leftValue} */}
          </Text>
          <Text
            style={{
              color: "#234D64",
              fontSize: 12,
            }}
          >
            {rightValue}
          </Text>
        </div>
      </div>
    );
  }
);

export default ProgressWithDetail;
